import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  authenticator: generateApiPath({ prefix: AuthLevel.AUTH, name: 'authenticator' }),
  user: generateApiPath({ prefix: AuthLevel.AUTH, name: 'user' }),
}

export { paths }
